import script from "./UserAuKycFinalize.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAuKycFinalize.vue?vue&type=script&setup=true&lang=ts"

import "./UserAuKycFinalize.vue?vue&type=style&index=0&id=a5759154&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5759154"]])

export default __exports__